import { gql } from "@apollo/client";

export const GET_PICKUP_AVAILABILITY = gql`
  query GetPickupAvailability($orderId: String!) {
    getPickupAvailability(orderId: $orderId) {
      latestTimeOptions
      pickupDate
      readyTimeOptions
    }
  }
`;

export const EDIT_PICKUP = gql`
  mutation EditPickup(
    $pickupId: String!
    $data: PickupUpdateInput!
    $where: PickupWhereUniqueInput!
    $trackingNumber: String
  ) {
    editPickup(
      pickupId: $pickupId
      data: $data
      where: $where
      trackingNumber: $trackingNumber
    ) {
      id
    }
  }
`;

export const CREATE_MANUAL_PICKUP = gql`
  mutation CreateManualPickup(
    $orderId: String!
    $scheduledDate: String!
    $trackingNumber: String!
    $comment: String
  ) {
    createManualPickup(
      orderId: $orderId
      scheduledDate: $scheduledDate
      trackingNumber: $trackingNumber
      comment: $comment
    ) {
      id
    }
  }
`;

export const CREATE_PICKUP = gql`
  mutation CreatePickup(
    $orderId: String!
    $scheduledDate: String!
    $clinicClosingTime: String
    $packageReadyTime: String
    $comment: String
  ) {
    createPickup(
      orderId: $orderId
      scheduledDate: $scheduledDate
      clinicClosingTime: $clinicClosingTime
      packageReadyTime: $packageReadyTime
      comment: $comment
    )
  }
`;

export const ABORT_PICKUP = gql`
  mutation AbortPickup($pickupId: String!) {
    abortPickup(pickupId: $pickupId)
  }
`;

export const GET_PICKUP_BY_DATE = gql`
  query getPickupByDate(
    $selectedDate: Timestamp!
    $take: Float!
    $skip: Float!
  ) {
    getPickupByDate(selectedDate: $selectedDate, take: $take, skip: $skip) {
      data {
        order {
          user {
            lastName
            firstName
          }
          patient {
            lastName
            firstName
          }
          userGroup {
            clinicNumber
            pickupCarrier
            name
          }
          id
          orderReference
        }
        id
        comment
        status
        confirmationCode
        closingTime
        scheduledDate
        shipping {
          trackingNumber
        }
      }
      totalCount
    }
  }
`;
